import { useUpdateCareerImage } from 'api/companies/hooks';
import { ImageInput } from 'components/image-input';
import { SettingsSection } from 'components/settings-section';
import { useStore } from 'models/Provider';
import { Company } from 'types/companies';

type CareerLogoProps = {
  companyInfo: Company;
};

export const CareerBanner = ({ companyInfo }: CareerLogoProps) => {
  const { t } = useStore();
  const submitBanner = useUpdateCareerImage();
  return (
    <SettingsSection
      title={t('company.settings.career.theme.banner.title')}
      description={t('company.settings.career.theme.banner.description')}
    >
      <ImageInput
        key={companyInfo.banner}
        url={companyInfo.banner}
        maxWidth={1200}
        onSave={(banner) => submitBanner.mutate({ banner })}
      />
    </SettingsSection>
  );
};
